package app.bloomey.web.pages.admin

import androidx.compose.runtime.*
import app.bloomey.web.components.layouts.AdminPageLayout
import app.bloomey.web.components.sections.PageActionsBar
import app.bloomey.web.components.widgets.*
import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.offCanvas.LocalOffCanvasController
import app.bloomey.web.core.offCanvas.items.VideoOffCanvasItem
import app.bloomey.web.modules.video.VideoContract
import app.bloomey.web.modules.video.VideoViewModel
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Page
@Composable
fun VideosPage() {
    val offCanvasController = LocalOffCanvasController.current
    val scope = rememberCoroutineScope()
    val viewModel = remember { VideoViewModel(scope) }
    val uiState by viewModel.observeStates().collectAsState()
    val nextPageState = uiState.nextPage

    val route = rememberPageContext().route
    val searchQuery = remember { mutableStateOf(route.queryParams["q"] ?: "") }

    val getPage = { page: Int ->
        viewModel.trySend(VideoContract.Inputs.GetVideos(page, size = 20, searchQuery.value))
    }
    LaunchedEffect(Unit) {
        getPage(1)
    }


    AdminPageLayout(pageTitle = "Video") {
        when {
            nextPageState is UiState.Success || nextPageState is UiState.Error -> {
                PageActionsBar(searchValue = searchQuery) {
                    getPage(1)
                }

                ShowingItems(modifier = Modifier.margin(bottom = 24.px), nextPageState.getData.totalItems)
                SimpleGrid(
                    modifier = Modifier.fillMaxWidth()
                        .margin(bottom = 40.px)
                        .rowGap(12.px)
                        .columnGap(16.px),
                    numColumns =
                    numColumns(base = 2, sm = 2, md = 3, lg = 4, xl = 5),
                ) {
                    uiState.videos.forEach { item ->
                        VideoItem(item) {
                            offCanvasController.push(VideoOffCanvasItem(item.id, video = it) {
                                getPage(1)
                            })
                        }
                    }
                }
            }
        }

        when (nextPageState) {
            is UiState.Error -> SiteErrorView(Modifier.minHeight(80.vh), text = nextPageState.errorMessage) {
                getPage(uiState.page)
            }

            UiState.Initial -> {}
            UiState.Loading -> LoadingView(Modifier.minHeight(80.vh))
            is UiState.Success -> {
                if (!uiState.lastPage)
                    SiteButton(modifier = Modifier.alignSelf(AlignSelf.Center), onClick = {
                        getPage(uiState.page + 1)
                    }) {
                        SpanText("Load More")
                    }
            }
        }
    }
}